import { render } from "./ManageInternalGroupingsModal.vue?vue&type=template&id=3e5c4dbe"
import script from "./ManageInternalGroupingsModal.vue?vue&type=script&lang=js"
export * from "./ManageInternalGroupingsModal.vue?vue&type=script&lang=js"

import "./ManageInternalGroupingsModal.vue?vue&type=style&index=0&id=3e5c4dbe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__